import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5db0dfb1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mxa-nologin-main" }
const _hoisted_2 = { class: "mxa-nologin-main-explanation" }
const _hoisted_3 = { "data-test": "area_desc_msg1" }
const _hoisted_4 = {
  key: 0,
  "data-test": "area_desc_msg1_other_ja"
}
const _hoisted_5 = { "data-test": "area_desc_msg2" }
const _hoisted_6 = { class: "mxa-nologin-main-input" }
const _hoisted_7 = { class: "container-fluid mb-2 p-0" }
const _hoisted_8 = { class: "row justify-content-center p-0" }
const _hoisted_9 = { class: "mxa-nologin-main-button-double" }
const _hoisted_10 = { class: "mxa-nologin-main-button-double" }

import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from '@/store'
import BaseButton from '@/components/common/button/BaseButton.vue'
import RegisterStepbar from '@/components/main/nologin/RegisterStepbar.vue'
import * as log from '@/model/util/log/Logger'
import { initDom, stateAgreeLicense, userAgreeLicense, topRedirect } from '@/model/components/users/userAgreeLicense'
import NologinTitle from '@/components/main/nologin/NologinTitle.vue'
import LicenseContents from '@/components/main/nologin/license/LicenseContents.vue'
import BaseAccordion from '@/components/common/parts/BaseAccordion.vue'
import { LANG_TYPE } from '@/i18n/langType'


export default /*#__PURE__*/_defineComponent({
  __name: 'AgreeLicense',
  props: {
  // ユーザー名
  username: {
    type: String,
    default: undefined,
  },
  // リダイレクト
  redirect: {
    type: String,
    default: undefined,
  },
  // ダウンロードキー
  downloadKey: {
    type: String,
    default: undefined,
  },
},
  setup(__props) {

const props = __props

log.trace('AgreeLicense setup start.')

// プロパティ定義


// 状態
const state = stateAgreeLicense(props)
const store = useStore()
const router = useRouter()

log.debug(`AgreeLicense props: ${JSON.stringify(props)}, state: ${JSON.stringify(state)}`)
// onMountedの登録
onMounted(async () => {
  log.trace('AgreeLicense onMounted start.')
  // F5等でusernameが設定されていない場合はTOP画面に遷移
  await initDom(state, store, router)
  log.trace('AgreeLicense onMounted end.')
})
/**
 * 同意ボタンクリック
 */
const onclick = async () => {
  log.trace('AgreeLicense onclick start.')
  // ワンタイムパスワード発行画面へ遷移
  userAgreeLicense(state, router)
  log.trace('AgreeLicense onclick end.')
}
/**
 * 同意しないボタンクリック
 */
const onback = async () => {
  log.trace('AgreeLicense onback start.')
  // TOP画面へ遷移
  topRedirect(state, store, router)
  log.trace('AgreeLicense onback end.')
}
log.trace('AgreeLicense setup end.')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(RegisterStepbar, {
      active: 1,
      type: "0"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(NologinTitle, {
        title: _ctx.$t('body.agree.title')
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('body.agree.message1')), 1),
        (!_unref(store).getters.isJapanese)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('body.agree.message1-other-ja')), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('body.agree.message2')), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(LicenseContents, {
          language: _unref(store).getters.language
        }, null, 8, ["language"])
      ]),
      (!_unref(store).getters.isJapanese)
        ? (_openBlock(), _createBlock(BaseAccordion, {
            key: 0,
            accordionId: "ja-original",
            headerTitle: _ctx.$t('body.agree.ja-original')
          }, {
            default: _withCtx(() => [
              _createVNode(LicenseContents, {
                language: _unref(LANG_TYPE).JA
              }, null, 8, ["language"])
            ]),
            _: 1
          }, 8, ["headerTitle"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(BaseButton, {
              label: _ctx.$t('body.agree.button.agree.title'),
              onButtonClick: onclick,
              "data-test": "agree_button"
            }, null, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(BaseButton, {
              label: _ctx.$t('body.agree.button.disagree.title'),
              onButtonClick: onback,
              "data-test": "back_button"
            }, null, 8, ["label"])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})